import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import React, { lazy, useState } from 'react';
import { useTranslation } from 'react-i18next';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));
const Modal = require(`globalcomponents/UI/Modal/${layout}`).default;
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const SvgIcon = lazy(() => import(`globalcomponents/SvgIcon/${layout}`));

export default function DeleteConfig({ row, handleDeleteAlert, callback }) {
  const i18n = useTranslation();
  const [del, setDelete] = useState(null);

  const onDelete = () => {
    setDelete(row);
  };

  const getContent = () => {
    return {
      content: () => (
        <div className="deleteParent">
          <div className="imageSection">
            <SvgIcon value={mediaUrls.confirmIcon} alt="Are you sure" />
          </div>
          <h2> {i18n.t('common.sureConfirm')} </h2>
          <p> {i18n.t('common.recoverConfirm')}</p>
          <div className="deletePopupBtn">
            <div className="cancelBtn">
              <Button
                label={i18n.t('Cancel')}
                type={'reset'}
                onClick={() => {
                  setDelete(null);
                }}
              ></Button>
            </div>
            <div className="deletebtn">
              <Button
                label={i18n.t('common.deletePopup')}
                onClick={() => {
                  handleDeleteAlert({
                    id: 'deleteAlert',
                    data: { id: row.id },
                    callback: callback,
                  });
                  setDelete(null);
                }}
              ></Button>
            </div>
          </div>
        </div>
      ),
    };
  };

  return (
    <>
      <Icon tooltip={i18n.t('common.delete')} src={mediaUrls?.deleteIcon} onClick={onDelete} />
      {del && <Modal open={true} setOpen={setDelete} data={getContent()} deletePopup />}
    </>
  );
}
